/* eslint-disable */ 

<template>
  <div class="list-wrapper">
    <p class="item-count">{{ listLength }} items</p>
    <div class="flex flex-row items-start">
      <ListColumn />
    </div>
    <button
      class="btn-grad"
      @click="clearList"
    >Clear List</button>
    <div class="white-space"></div>
    <div
      class="item-bg"
      v-if="isItemOpen"
      @click.self="close"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import ListColumn from "../components/ListColumn.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    ListColumn,
  },
  computed: {
    isItemOpen() {
      return this.$route.name === "item";
    },
    ...mapGetters(["listLength"]),
  },
  methods: {
    clearList() {
      if (confirm("Are you sure you want to clear the shopping list?")) {
        this.$store.commit("CLEAR_LIST");
      }
    },
    close() {
      this.$router.push({ name: "list" });
    },
  },
  beforeCreate() {
    this.$store.commit("FETCH_LIST");
  },
};
</script>

<style lang="css">
html {
  @apply p-4 bg-teal-dark h-full;
  background-color: #f8b195;
}

.list-wrapper {
  width: 95%;
  max-width: 600px;
  position: relative;
  margin-right: auto;
  margin-left: auto;
}

.item-count {
  text-align: left;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  padding: 15px 0px 10px 0px;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.26);
}

.white-space {
  height: 40px;
}

.btn-grad {
  margin-bottom: 50px;
  margin-top: 35px;
}

.btn-grad {
  background-image: linear-gradient(
    to right,
    #f67280 2%,
    #c06c84 51%,
    #6c5b78 100%
  );
}
.btn-grad {
  margin: 40px auto 0px auto;
  padding: 10px 30px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.301);
  border-radius: 10px;
  display: block;
  font-weight: 500;
}

.item-bg {
  @apply pin fixed;
  background: rgba(0, 0, 0, 0.5);
}
</style>
